module.exports = __webpack_public_path__ + "static/media/009.d4ef448c.jpg";